export default function BreadCrumbSection() {
	return (
		<div className="fugu--breadcrumbs-section">
			<div className="container">
				<div className="fugu--breadcrumbs-data dark-content">
					<h1>We are creative thinkers about NFTs</h1>
					<p>
						An NFT is a digital asset that represents real-world objects like art, music, in-game items, and
						videos. They are bought and sold online frequently with cryptocurrency, & they are generally
						encoded with the same underlying software as many cryptos.
					</p>
				</div>
			</div>
		</div>
	);
}
